var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"filter-list-header\">\n	<h2>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"portletTitle") || (depth0 != null ? lookupProperty(depth0,"portletTitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"portletTitle","hash":{},"data":data,"loc":{"start":{"line":2,"column":5},"end":{"line":2,"column":21}}}) : helper)))
    + "</h2>\n</div>\n<div class=\"records-list\"></div>\n";
},"useData":true});